export interface AuthState {
    isLoggedIn: boolean;
    loggedInUser: User | null;
    isInitialized: boolean;
}

export interface User {
    id: string;
    username: string;
    email: string;
    role: UserRole;
    last_login: string;
}

export enum UserRole {
    ADMIN = "admin",
    MANAGER = "manager",
    ASSISTANT = "assistant",
    NORMAL_USER = "normal"
}